/* TYVEXO floating WhatsApp button — desktop tooltip timing */
(function () {
  var isDesktop = window.matchMedia('(min-width: 990px)').matches;
  if (!isDesktop) return;

  var wrapper = document.getElementById('tyvexo-whatsapp');
  var tooltip = document.getElementById('tyvexo-whatsapp-tooltip');
  if (!wrapper || !tooltip) return;

  var hideTimer = null;

  function showTooltip() {
    clearTimeout(hideTimer);
    tooltip.classList.add('is-visible');
  }

  function hideTooltip() {
    clearTimeout(hideTimer);
    tooltip.classList.remove('is-visible');
  }

  // Auto-show once on page load, stay visible for exactly 2s, then fade out.
  // Never scheduled again after this — no repeat during the same page visit.
  setTimeout(function () {
    showTooltip();
    hideTimer = setTimeout(hideTooltip, 2000);
  }, 4000);

  wrapper.addEventListener('mouseenter', showTooltip);
  wrapper.addEventListener('mouseleave', hideTooltip);
  wrapper.addEventListener('focusin', showTooltip);
  wrapper.addEventListener('focusout', hideTooltip);
})();
